import { withInstall } from '@jdesign-vue/utils'
import TimeSelect from './src/time-select.vue'

export const JdTimeSelect = withInstall(TimeSelect)
export default JdTimeSelect
